import { css } from 'styled-components';
import { mediaTemplates } from 'theme/variables';

export const embedWrapper = css`
  ${(props) =>
    props.size === 's' &&
    css`
      ${mediaTemplates.xxs} {
        width: 135px;
      }
      ${mediaTemplates.m} {
        width: 160px;
      }
      ${mediaTemplates.l} {
        width: 180px;
        height: 45px;
      }
    `}
  ${(props) =>
    props.size === 'm' &&
    css`
      ${mediaTemplates.m} {
        width: 180px;
      }
      ${mediaTemplates.l} {
        height: 45px;
      }
    `}
  ${(props) =>
    props.size === 'l' &&
    css`
      ${mediaTemplates.l} {
        width: 200px;
        height: 45px;
      }
    `}
  ${(props) =>
    props.size === 'xl' &&
    css`
      ${mediaTemplates.xs} {
        width: 200px;
      }
      ${mediaTemplates.l} {
        width: 280px;
        height: 45px;
      }
    `}
`;

export const embedExpandPrice = css`
  ${mediaTemplates.m} {
    display: inline;
  }
`;

export const embedExpandQuality = css`
  ${mediaTemplates.l} {
    display: inline;
  }
`;
